import { isNil } from "ramda";
import { create } from "js-sha1";
import { getAttributeValue } from "@/utils";

export function decorateProduct(product) {
  product.unitNetPriceDisplay = isNil(product.unitNetPrice)
    ? "Market Price"
    : `$${product.unitNetPrice.toFixed(2)}`;
  product.package = {
    isPackage: getAttributeValue(product.attributes, "isPackage"),
    packageOptions: getAttributeValue(product.attributes, "packageOptions"),
  };
  product.specification = {
    isSpecificationEnabled: getAttributeValue(
      product.attributes,
      "isSpecificationEnabled",
      false
    ),
    specificationOptions: getAttributeValue(
      product.attributes,
      "specificationOptions",
      []
    ).map((specOption) => ({
      ...specOption,
      unitNetPriceDisplay: Number(specOption.unitNetPrice).toFixed(2),
    })),
  };
  product.isSoldOut = getAttributeValue(product.attributes, "isSoldOut");
  product.isDetailPageEnabled = getAttributeValue(
    product.attributes,
    "isDetailPageEnabled"
  );
  product.isEventProduct = getAttributeValue(
    product.attributes,
    "isEventProduct"
  );
  product.isShowItemNumberInputInDetailPage =
    !product.package.isPackage &&
    !product.specification.isSpecificationEnabled &&
    (!product.subProducts || product.subProducts.length === 0);
  product.subProducts &&
    product.subProducts.forEach((subProduct) => {
      subProduct.unitNetPriceDisplay = `$${subProduct.unitNetPrice.toFixed(2)}`;
    });
  product.availableTimeslots = getAttributeValue(
    product.attributes,
    "availableTimeslots",
    []
  );
  product.detailGalleryImageUrls = [
    product.originalFeaturedImageUrl,
    ...product.galleryImages.map(img => img.url)
  ];
}

export function generateCategorySlug(category, childCategory) {
  return create()
    .update(
      [category.name, (childCategory && childCategory.name) || ""]
        .filter((c) => c)
        .join("___")
    )
    .hex();
}
